import TicketsRepository from "@adapters/features/TicketPortal/Repository/Tickets";
import { accountDetails } from "@di";
export default (http) => {
    return {
        ticketData: new TicketsRepository(http, accountDetails),
    };
};
